import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { RadioGroupModule } from 'app/shared/components/radio-group/radio-group.module';
import { FilterHistoryComponent } from './filter-history.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    RadioGroupModule,
    ModalModule,
  ],
  declarations: [FilterHistoryComponent],
  exports: [FilterHistoryComponent],
})
export class FilterHistoryModule {}
